import { z } from 'zod';
/**
 * Corps des endpoints de réattribution d'auteur (devis, réponse de devis,
 * dossier, prestation). Réservé au superadmin : `createdById` alimente les
 * statistiques par collaborateur, le réécrire déplace de la production d'un
 * agent à un autre.
 *
 * `null` est une valeur légitime et non un champ omis : c'est ainsi qu'on rend
 * une affaire à « sans auteur » — la demande venue du site, le checkout
 * autonome. D'où le `.nullable()` sans `.optional()` : un corps vide est une
 * erreur de l'appelant, pas une remise à zéro implicite.
 */
export const updateAuthorSchema = z.object({
    adminId: z.string().min(1).nullable(),
});
